<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import EADtlForm from "../../../components/payroll/eadtl/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": EADtlForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('eadtl.addeadtl'),
      pageTitleValue: "",
      formData:{
        id: null,
        eaaddondetail: [],
        year: null,
        staffid: null,

        stamp: 0,
        userid: this.$store.getters.userId,
      },
      errMsg: "",
      confirmMsg: "",
      isErr: false,
      loading: true,
      editMode: true,
      isConfirm: false,
      userid: this.$store.getters.userId,
    };
  },

  methods: {
    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      vm.formData.userid = this.$store.getters.userId;

      this.$store.dispatch('post', {url: "/eadtl", payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = true;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "eadtllist" });
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "eadtllist" });
    },
  },
};
</script>